<template>
  <b-col md="6">
    <form-group :validations="validation">
      <div slot-scope="{ errors, invalid }">
        <b-alert show class="overflow_div ">

            <div  class="selected-category-section">
              <span class="badge badge-primary m-1" style="cursor: pointer" v-for="(item,index) in selectedCheckBoxes"
                    @dblclick="removeCategory(index)">{{ item.name }}</span>

              <div class="col-12 mt-3">
                <label
                >{{ label }}
                  <b-icon
                      icon="arrow-clockwise"
                      class="d-inline"
                      @click="refreshCategories"
                  ></b-icon>
                </label>

                <b-form-input
                    id="input"
                    v-model="searchedWord"
                    placeholder=" جستجو"
                    class="mb-1"
                ></b-form-input>
              </div>

            </div>

          <b-form-group :class="{ invalid }">


            <category
                :remove-category="removeCategory"
                :selected-category="selectedCheckBoxes"
                :margin="0"
                v-for="category in searchedCategory"
                :key="category.id"
                :category="category"
            />
          </b-form-group>
        </b-alert>
        <form-errors-manager :errors="errors"/>
      </div>
    </form-group>
  </b-col>
</template>
<script>
import FormGroup from "../../../validator/FormGroup.vue";
import FormErrorsManager from "../../../validator/FormErrorsManager.vue";
import category from "../../product/category.vue";
import {flatCategories} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Category";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "CheckBoxManager",
  components: {FormGroup, FormErrorsManager, category},
  props: ["validation", "CheckBoxItems", "selectedCheckBoxes", "label"],
  data() {
    return {
      selected: this.selectedCheckBoxes,
      searchedWord: '',
    };
  },
  computed: {
    searchedCategory() {
      if (this.searchedWord.length === 0) {
        return this.CheckBoxItems
      }

      return flatCategories(this.CheckBoxItems).filter(item => {
        return item.name.indexOf(this.searchedWord) > -1
      })
    }
  },
  methods: {
    refreshCategories() {
      this.$store.dispatch("Category/getDashboardCategories");
    },
    removeCategory(category) {
        this.selectedCheckBoxes.splice(category, 1);
        toast('ایتم حذف شد','ایتم حذف شد','success','top-left')
    },
  },
};
</script>
<style scoped>
.overflow_div {
  width: auto;
  height: 700px !important;
  overflow-y: auto;
}

.selected-category-section{
  position: sticky;
  top: 0; /* or bottom: 0; */
  background-color: #f0f0f0;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}

</style>